import * as React from 'react';

interface ISilentScrollerProps {
	children?: any;
}

type Props = ISilentScrollerProps;

export class SilentScroller extends React.Component<Props, {}> {
	public render() {
		const { children } = this.props;
		const height = window.innerHeight;
		return (
			<div style={{height: `${height}px`, overflow: 'hidden'}}>
				<div id={'parallaxParent'} style={{paddingRight: '20px', paddingBottom: '40px', overflowY: 'scroll', overflowX: 'hidden', height: '100vh', width: '100%'}}>
					<div style={{width: '100vw', overflowX: 'hidden'}}>
						{children}
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/SilentScroller.tsx